"use client";

import React, { useState } from "react";
import { useRouter, useSearchParams, usePathname } from "next/navigation";

const SearchBox = ({ keyword = "" }) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const searchTextFromQueryString = searchParams.get("searchtext") || "";
  const [searchText, setSearchText] = useState(
    keyword || searchTextFromQueryString
  );

  const handleSearch = (text) => {
    if (
      (text.length > 0 && text.length < 3 && !Number(text)) ||
      (Number(text) && text.length == 1)
    ) {
      return null;
    }
    const params = new URLSearchParams(searchParams.toString());
    params.delete("searchtext");
    params.delete("page");

    if (text !== "") {
      params.set("searchtext", text);
    }

    // On concerts, every new search starts from All Presenters.
    if (pathname === "/concerts" && text !== "") {
      params.set("tps_activeFacetTab", "All Presenters");
    }

    const qs = params.toString();
    router.push(qs ? `?${qs}` : "?");
  };

  return (
    <div className="tps-search-box search-results-page">
      <div id="SmartSearchBox_pnlSearch" className="searchBox">
        <label
          htmlFor="SmartSearchBox_txtWord"
          id="SmartSearchBox_lblSearch"
          style={{ display: "none" }}
        >
          Search For:
        </label>
        <input
          name="p$lt$ctl03$pageplaceholder$p$lt$ctl02$SmartSearchBox$txtWord"
          type="text"
          maxLength="1000"
          id="SmartSearchBox_txtWord"
          className="form-control"
          onClick={() => setSearchText("")}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              handleSearch(searchText);
            }
          }}
          value={searchText}
          suppressHydrationWarning={true}
        />
        <input
          type="submit"
          name="p$lt$ctl03$pageplaceholder$p$lt$ctl02$SmartSearchBox$btnSearch"
          value="Search Courses"
          id="SmartSearchBox_btnSearch"
          className="tps-icon-search btn btn-default"
          onClick={() => handleSearch(searchText)}
        />
        {searchText !== "" && (
          <button
            type="button"
            className="tps-search-box-clear"
            onClick={() => {
              setSearchText("");
              handleSearch("");
            }}
          >
            <span className="fal fa-times-circle" aria-hidden="true"></span>
            <span className="sr-only">Clear Search Term</span>
          </button>
        )}

        <div
          id="SmartSearchBox_pnlPredictiveResultsHolder"
          className="predictiveSearchHolder"
        ></div>
      </div>
    </div>
  );
};

export default SearchBox;
